import { getData, postData, putData } from 'src/api/http.service';
import {
  handleApiError,
  handleApiSuccess,
  generateUserInfoHeader,
  getDataFromSessionStorage,
  getAPIEndpoints,
} from 'src/utils/general.utils';
import { ApiCallFailedAction, ApiCallInProgress, ApiCallSuccessAction } from './uistate.action';
const CouponManageActionTypes = {
  LOAD_COUPONS_SUCCESS: '[API] : LOAD_COUPONS_SUCCESS',
  ADD_COUPON_SUCCESS: '[API] : ADD_COUPON_SUCCESS',
  UPDATE_COUPON_SUCCESS: '[API] : UPDATE_COUPON_SUCCESS',

  LOAD_CATALOGUE_SUCCESS: '[API] : LOAD_CATALOGUE_SUCCESS',
};

// plain actions*************************************************************************8

function AllCouponsSuccessAction(payload) {
  return {
    type: CouponManageActionTypes.LOAD_COUPONS_SUCCESS,
    payload,
  };
}

function CreateNewCouponSuccessAction(payload) {
  return {
    type: CouponManageActionTypes.ADD_COUPON_SUCCESS,
    payload,
  };
}

function UpdateCouponSuccessAction(payload) {
  return {
    type: CouponManageActionTypes.UPDATE_COUPON_SUCCESS,
    payload,
  };
}

function AllCatalogueSuccessAction(payload) {
  return {
    type: CouponManageActionTypes.LOAD_CATALOGUE_SUCCESS,
    payload,
  };
}

// ASYNC actions ************************************************************************************
function GetAllCouponsAction(payload, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await getData(
        payload,
        generateUserInfoHeader(getDataFromSessionStorage('userRoles'))
      );
      dispatch(AllCouponsSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err)));
    }
  };
}

function CreateNewCouponAction(url, data, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await postData(
        url,
        data,
        generateUserInfoHeader(getDataFromSessionStorage('userRoles'))
      );
      dispatch(CreateNewCouponSuccessAction(response.data));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      dispatch(GetAllCouponsAction(getAPIEndpoints().getAllCoupons));
      return { status: true, apiRes: response };
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err)));
      return { status: false, apiRes: handleApiError(err) };
    }
  };
}

function CheckMobileNumberAction(payload, data, headers) {
  return async () => {
    try {
      const response = await getData(payload, data, headers);
      return response;
    } catch (err) {
      return handleApiError(err);
    }
  };
}

function UpdateCouponAction(url, data, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await putData(
        url,
        data,
        generateUserInfoHeader(getDataFromSessionStorage('userRoles'))
      );
      dispatch(UpdateCouponSuccessAction(response.data));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      dispatch(GetAllCouponsAction(getAPIEndpoints().getAllCoupons));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err)));
      return false;
    }
  };
}

function GetAllCataloguesAction(payload, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await getData(payload);
      dispatch(AllCatalogueSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err)));
    }
  };
}

function GetSingleCouponAction(payload, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await getData(payload);
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return {
        status: true,
        couponDetails: response.data,
      };
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err)));
      return {
        status: false,
      };
    }
  };
}

function ExpireCouponAction(payload, data, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await postData(payload, data, headers);
      dispatch(UpdateCouponSuccessAction(response.data));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      dispatch(GetAllCouponsAction(getAPIEndpoints().getAllCoupons));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err)));
      return false;
    }
  };
}

export {
  CouponManageActionTypes,
  AllCouponsSuccessAction,
  CreateNewCouponSuccessAction,
  UpdateCouponSuccessAction,
  AllCatalogueSuccessAction,
  GetAllCouponsAction,
  CreateNewCouponAction,
  UpdateCouponAction,
  GetAllCataloguesAction,
  CheckMobileNumberAction,
  GetSingleCouponAction,
  ExpireCouponAction,
};
